import { render, staticRenderFns } from "./ot-project-documents-index.vue?vue&type=template&id=722d1a38&scoped=true&"
import script from "./ot-project-documents-index.vue?vue&type=script&lang=ts&"
export * from "./ot-project-documents-index.vue?vue&type=script&lang=ts&"
import style0 from "./ot-project-documents-index.vue?vue&type=style&index=0&id=722d1a38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722d1a38",
  null
  
)

export default component.exports